import type { PaginationState } from 'redux/reusable/pagination';
import { createPaginationModule } from 'redux/reusable/pagination';
import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule } from 'redux/reusable/xhrStatus';
import type {
  LightProjectWithRate,
  LightProjectWithRateAndPermission,
  RateType,
} from 'types/project';
import type { UserDraftProject, UsersDraft } from 'types/users';
import { actionCreatorFactory } from 'typescript-fsa';

export const userEditorXhrModule = createXhrStatusModule('user.editor');
const actionCreator = actionCreatorFactory('timely/user.editor');
export const { withPaginationReducer: wrapPaginationReducer, paginationActions } =
  createPaginationModule('user.editor-pagination');

export const createDraft = actionCreator<UsersDraft>('CREATE_DRAFT');
export const updateDraft = actionCreator<Partial<UsersDraft>>('UPDATE_DRAFT');
export const updateDraftUserProperty = actionCreator<{ id: number; value: string }>(
  'UPDATE_DRAFT_USER_PROPERTY'
);
export const clearDraft = actionCreator('CLEAR_DRAFT');
export const createDraftOriginal = actionCreator<UsersDraft>('CREATE_DRAFT_ORIGINAL');
export const clearDraftOriginal = actionCreator('CLEAR_DRAFT_ORIGINAL');
export const updateDraftDefaultHourRate = actionCreator<number>('UPDATE_DRAFT_DEFAULT_HOUR_RATE');
export const updateDraftInternalCostRate = actionCreator<number>('UPDATE_DRAFT_INTERNAL_COST_RATE');
export const removeTeamFromUser = actionCreator<number>('REMOVE_TEAM_FROM_USER');
export const addProjectAssociationToDraft = actionCreator<UserDraftProject>(
  'ADD_PROJECT_ASSOCIATION_TO_DRAFT'
);
export const applyDefaultRateForChosenProjects = actionCreator(
  'APPLY_DEFAULT_RATE_FOR_CHOSEN_PROJECTS'
);
export const updateDraftProjectRate = actionCreator<UserDraftProject>('UPDATE_DRAFT_PROJECT_RATE');
export const removeProjectAssocationFromDraft = actionCreator<number>(
  'REMOVE_PROJECT_ASSOCIATION_FROM_DRAFT'
);
export const disassociateAllProjects = actionCreator('DISASSOCIATE_ALL_PROJECTS');

export const receiveProjectsForDropdown = actionCreator<{
  projects: Array<LightProjectWithRateAndPermission>;
  tagIds?: Array<number>;
}>('RECEIVE_PROJECTS_FOR_DROPDOWN');
export const receiveProjectsCountForClient = actionCreator<{ clientId: number; count: number }>(
  'RECEIVE_PROJECTS_COUNT_FOR_CLIENT'
);

export const receiveProjectsForRatesList = actionCreator<Array<LightProjectWithRateAndPermission>>(
  'RECEIVE_PROJECTS_FOR_RATE_LIST'
);
export const setProjectRateFilters = actionCreator<Partial<ProjectRateFilters>>(
  'SET_PROJECT_RATE_FILTERS'
);

export interface ProjectRateFilters {
  queryString: string;
  rateType: RateType | null;
}

export interface State {
  draft: UsersDraft | null;
  draftOriginal: UsersDraft | null;
  projectsForDropdown: Array<LightProjectWithRateAndPermission>;
  projectsIdsByTagId: Record<number, Array<number>>;
  xhrStatus: XhrStatus;
  paginatedProjectRateList: Array<LightProjectWithRate>;
  projectRateFilters: ProjectRateFilters;
  pagination: PaginationState;
}

export enum InternalCostRateChange {
  NewOnly = 'new',
  All = 'all',
}
